import React, { useEffect, useRef } from "react";
import styles from './index.module.css';
import gsap from "gsap";
import chroma from "chroma-js";

const GlowButton = (props) => {

    const button = useRef();

    useEffect(() => {
        if (button.current !== undefined) {
                button.current.addEventListener("pointermove", (e) => {
                    const rect = button.current.getBoundingClientRect();
        
                    const x = e.clientX - rect.left;
                    const y = e.clientY - rect.top;
        
                    gsap.to(button.current, {
                        "--pointer-x": `${x}px`,
                        "--pointer-y": `${y}px`,
                        duration: 0.6,
                    });
        
                    gsap.to(button.current, {
                        "--button-glow": chroma
                        .mix(
                            getComputedStyle(button.current)
                            .getPropertyValue("--button-glow-start")
                            .trim(),
                            getComputedStyle(button.current).getPropertyValue("--button-glow-end").trim(),
                            x / rect.width
                        )
                        .hex(),
                        duration: 0.2,
                    });
                });
            }
    }, [button]);

    return (
        <div className={styles["container"]}>
        <button onClick={props.onClick} ref={button} className={styles["glow-button"]}>
            <span>{props.text}</span>
            <div className={styles["gradient"]}/>
        </button>
        </div>
    )
}

export default GlowButton;